/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReactivateMembershipMutationVariables = Types.Exact<{
  organisationId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
}>;


export type ReactivateMembershipMutation = { reactivateOrganisationMembership: { __typename: 'ReactivateOrganisationMembershipResult', user: { __typename: 'User', id: string, membershipStatus: Types.OrganisationMembershipStatus } } };


export const ReactivateMembershipDocument = gql`
    mutation ReactivateMembership($organisationId: ID!, $userId: ID!) {
  reactivateOrganisationMembership(
    input: {organisationId: $organisationId, userId: $userId}
  ) {
    user {
      id
      membershipStatus
    }
  }
}
    `;
export type ReactivateMembershipMutationFn = Apollo.MutationFunction<ReactivateMembershipMutation, ReactivateMembershipMutationVariables>;

/**
 * __useReactivateMembershipMutation__
 *
 * To run a mutation, you first call `useReactivateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateMembershipMutation, { data, loading, error }] = useReactivateMembershipMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useReactivateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateMembershipMutation, ReactivateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateMembershipMutation, ReactivateMembershipMutationVariables>(ReactivateMembershipDocument, options);
      }
export type ReactivateMembershipMutationHookResult = ReturnType<typeof useReactivateMembershipMutation>;
export type ReactivateMembershipMutationResult = Apollo.MutationResult<ReactivateMembershipMutation>;
export type ReactivateMembershipMutationOptions = Apollo.BaseMutationOptions<ReactivateMembershipMutation, ReactivateMembershipMutationVariables>;